import { AxiosResponse } from 'axios';
import { postRequest } from '../../Services/HttpService';
import { IMapSettingsValue } from './types';

export const saveMapSettings = async (mapSettings: IMapSettingsValue): Promise<any> => {
  const response: AxiosResponse | false = await postRequest(
    '/v1/user-settings/map_settings/save',
    mapSettings,
    { returnAxiosResponse: true }
  );
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};
